import { Component } from "@angular/core";
import { LINK_PAGES } from "src/constants/param-constants";


@Component({
  standalone: true,
  selector: "app-privacy-policy",
  template: ""
})
export class PrivacyPolicyComponent {
  constructor() {
    // We won't render the GDPR page, so redirecting to the legal site
    window.open(`${LINK_PAGES.PRIVACY_POLICY}`, '_top');
  }
}
